<div class="header">
  <nav>
    <div class="pull-right mr-4 mt-2">
      <a class="mt-3 mx-2 border rounded border-primary p-2"
         routerLink="/services/categories"
         *hasPermission="['services-category.view']"
         style="text-decoration: none; cursor: pointer">
        <ezy-icons src="/assets/icons/list-ui-alt.svg"></ezy-icons>
        Manage Categories
      </a>
      <a class="mt-3 mx-2 border rounded border-primary p-2"
         routerLink="/services/service-providers"
         *hasPermission="['service-provider.view']"
         style="text-decoration: none; cursor: pointer">
        <ezy-icons src="/assets/icons/user-arrows.svg"></ezy-icons>
        Manage Suppliers
      </a>
      <a class="btn btn-primary"
         routerLink="new"
         *hasPermission="['services.create']"
         style="min-width: 150px">
        <ezy-icons src="/assets/icons/plus.svg"></ezy-icons>
        Add Service
      </a>
    </div>
    <ol class="breadcrumb mr-auto">
      <li class="breadcrumb-item"
          aria-current="page">App content</li>
      <li class="breadcrumb-item"
          *hasPermission="['services.view']">
        <a routerLink="/services">Services</a>
      </li>
    </ol>
  </nav>
  <hr />
</div>

<div class="px-4">
  <h3>Services</h3>
  <div class="row">
    <div class="col-12 col-md-auto">
      <div class="w-100 h-100 d-flex align-items-center">
        <div class="searchbox"
             style="width: 180pt">
          <span type="submit"
                class="ui-dropdown-filter-icon pi pi-search text-muted"></span>
          <input type="text"
                 class="form-control"
                 (input)="dataTable.filterGlobal($event.target.value, 'contains')"
                 pInputText
                 [size]="50"
                 placeholder="Search services" />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <div id="floatContainer"
           class="float-container-">
        <label for="Published"
               class="dropdown-label"
               onclick="document.getElementById('Published').click()"><small>Published</small>
          <select class="custom-select-"
                  id="Published"
                  (change)="filterByPublished($event)">
            <option selected
                    value="">All Services</option>
            <option [value]="true">True</option>
            <option [value]="false">False</option>
          </select>
        </label>
      </div>
    </div>
    <div class="col-12 col-md-auto d-none">
      <div id="floatContainer"
           class="float-container-">
        <label for="SortBy"
               class="dropdown-label"
               onclick="document.getElementById('SortBy').click()"><small>Sort By</small>
          <select class="custom-select-"
                  id="SortBy">
            <option selected
                    value="">Latest</option>
          </select>
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card mt-4">
        <div class="card-body">
          <p-table [value]="services$|async"
                   [paginator]="true"
                   [rows]="10"
                   #dataTable
                   [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
                   [loading]="loading"
                   [scrollable]="true"
                   [scrollHeight]="'500px'"
               
            >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">#</th>
                <th>Service</th>
                <th>Packages</th>
                <th>Start Price</th>
                <th>Orders</th>
                <th>Country</th>
                <th [pSortableColumn]="'created_at'">
                  Date Added
                  <p-sortIcon [field]="'created_at'"></p-sortIcon>
                </th>
                <th>Published</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-service
                         let-i="rowIndex">
              <tr>
                <td style="width: 3rem">
                  {{ i + 1 }}
                </td>
                <td>
                  <div class="row"
                       style="border: none">
                    <div class="col-md-6 p-0">
                      <img src="{{ service.icon }}"
                           alt="{{ service.name }}"
                           class="img-fluid"
                           style="width: 61px; height: 55px; border-radius: 8px" />
                    </div>
                    <div class="col-md-6 p-0"
                         style="
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 19px;
                        color: #000000;
                      ">
                      <!-- service name -->
                      <a [routerLink]="['/services', service.id]">{{
                        service.name | titlecase
                        }}</a>
                      <!-- service supplier -->
                      <span class="supplier">
                        {{ service.service_provider }}
                      </span>
                      <p-rating [ngModel]="service.rating"
                                [readonly]="true"
                                [cancel]="false"></p-rating>
                    </div>
                  </div>
                </td>
                <td class="text-justify">{{ service.packaging.length }}</td>
                <td>{{ service.startPrice | currency: "UGX" }}</td>
                <td class="orders-row">{{ service.orders || 0 }}</td>
                <td>{{ service.country}}</td>
                <td>{{ service.created_at }}</td>
                <td>
                  <i (click)="togglePublished(service)"
                     class="pi"
                     [ngClass]="{
                      'true-icon pi-check-circle text-success':
                        service.published,
                      'false-icon pi-times-circle text-danger':
                        !service.published
                    }"></i>
                </td>
                <td>
                  <!-- <button class="btn btn-outline-primary-dark"
                          *hasPermission="['services.view']"
                          (click)="editService(service.id)">
                    View Details
                  </button> -->
                  <button class="btn btn-outline-primary-dark">
                    View Details
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
